import PropTypes from 'prop-types';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import ServerErrorAlert from 'src/components/ui/ServerErrorAlert';

import FormCardStyled from './styled/FormCardStyled';

const FormCard = (props) => {
	const {
		title,
		subtitle,
		error,
		isLoading,
		pre,
		children,
		fullHeight,
		acceptLabel = 'Добавить',
		cancelLabel = 'Отменить',
		loadingLabel = 'Загрузка...',
		onAccept,
		onSubmit,
		onCancel,
		btnsNode,
		acceptDisabled,
	} = props;

	return (
		<FormCardStyled fullHeight={fullHeight}>
			<form onSubmit={onSubmit}>
				<CardHeader
					sx={{ pl: 2, pr: 2 }}
					title={title}
					subheader={subtitle}
				/>
				{pre && <Box sx={{ my: 1 }}>{pre}</Box>}
				<CardContent sx={{ p: 2 }}>
					<Box>{children}</Box>
				</CardContent>
				{error && (
					<Box p={[1, 2]}>
						<ServerErrorAlert error={error} />
					</Box>
				)}

				<CardActions sx={{ p: 2 }}>
					{onAccept && (
						<Button
							variant="contained"
							onClick={isLoading ? undefined : onAccept}
							disabled={isLoading || acceptDisabled}
						>
							{isLoading ? loadingLabel : acceptLabel}
						</Button>
					)}
					{onCancel && (
						<Button variant="text" onClick={onCancel}>
							{cancelLabel}
						</Button>
					)}
					{btnsNode}
				</CardActions>
			</form>
		</FormCardStyled>
	);
};

FormCard.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	error: ServerErrorAlert.propTypes.error,
	loadingLabel: PropTypes.string,
	isLoading: PropTypes.bool,
	children: PropTypes.node,
	pre: PropTypes.node,
	fullHeight: PropTypes.bool,
	acceptLabel: PropTypes.string,
	cancelLabel: PropTypes.string,
	onSubmit: PropTypes.func,
	onAccept: PropTypes.func,
	onCancel: PropTypes.func,
	btnsNode: PropTypes.node,
	acceptDisabled: PropTypes.bool,
};

export default FormCard;
